module.exports = __webpack_public_path__ + "1dcb16449216711c9d3a50e32a860f13.svg";